import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-expired-error",
  standalone: true,
  imports: [],
  templateUrl: "./expired-error.html",
  styleUrl: "./expired-error.scss",
})
export class ExpiredError {
  constructor(private router: Router) {}

  goToForgotPassword() {
    this.router.navigate(["/forgot-password"]);
  }

  goHome() {
    this.router.navigate(["/login"]);
  }
}
